<wbo-search-page (prepareInitialFilter)="prepareInitialFilter()"  [showAddButton]="false" >
    <wbo-search-form>
        <wbo-search-form-fields>
            <wbo-search-form-field field="metaTagName">
                <wbo-simple-search-control></wbo-simple-search-control>
            </wbo-search-form-field>
            <wbo-search-form-field field="metaTagValueName">
                <wbo-simple-search-control></wbo-simple-search-control>
            </wbo-search-form-field>
            <wbo-search-form-field *ngIf="showTypeFilter" field="type">
                <wbo-single-select-search-control initialDefaultValue="all">
                    <wbo-select-options>
                        <wbo-select-option label="wbo.preparation-modifier.option.modifier-type.all" value="all"></wbo-select-option>
                        <wbo-select-option label="wbo.preparation-modifier.option.modifier-type.preparation" value="preparation"></wbo-select-option>
                        <wbo-select-option label="wbo.preparation-modifier.option.modifier-type.message" value="prepared message"></wbo-select-option>
                    </wbo-select-options>
                </wbo-single-select-search-control>
            </wbo-search-form-field>
        </wbo-search-form-fields>
    </wbo-search-form>
    <wbo-search-grid>
        <wbo-main-search-column field="metaTagName"></wbo-main-search-column>
        <wbo-column field="metaTagValueName"></wbo-column>
        <wbo-column field="type"></wbo-column>
    </wbo-search-grid>
</wbo-search-page>
